export const API_URL = process.env.VUE_APP_API_URL
export const ID_API_URL = process.env.VUE_APP_ID_API_URL
